import { useEffect, useRef, useState } from 'react'
import { UploadFile, DefaultButton } from 'components'
import { useAuth } from 'hooks'
import { Icon } from 'assets'
import { hasAccess, UUID } from 'helper/utils'
import { CONNECTION } from 'configs/configs.js'
import { IObject } from 'interfaces'
import { Formulary } from './style'

const options = {
  accept: '.pdf',
  info: '• Documento no formato PDF',
  icon: 'image.svg',
  label: 'Upload de PDF',
}

interface IProps {
  onChange?: (_event: FormData) => void
  formdata?: FormData
  documentList?: Array<IObject>
  readonly?: boolean
  readAdd?: boolean
}

export default function (props: IProps) {
  const { onChange, formdata, documentList, readonly, readAdd } = props
  const [filePrompt, setFilePrompt] = useState<string | undefined>()
  const [inputList, setInputList] = useState<any[]>([])
  const fileList = useRef<FormData>(formdata || new FormData())
  const { token } = useAuth()

  useEffect(() => {
    console.log('lista de documentos', documentList)
    if (!documentList) return
    setInputList(
      documentList.map((document: IObject) => ({
        id: UUID(),
        type: document.type,
        name: document.name,
        url: `${CONNECTION.URL}/app/protected/${document.file}?token=${token}`,
        status: document.status,
      }))
    )
  }, [])

  function handleUpdate() {
    onChange && onChange(fileList.current)
  }

  return (
    <Formulary>
      {/* Buttons */}
      {readonly || (
        <>
          <div className="container">
            <DefaultButton
              id={'add-document-button'}
              small
              icon={Icon('plus.svg')}
              onClick={() => setFilePrompt('document')}
            >
              Novo documento
            </DefaultButton>
            <DefaultButton
              id={'add-document-button'}
              small
              icon={Icon('plus.svg')}
              onClick={() => setFilePrompt('attachment')}
            >
              Novo anexo
            </DefaultButton>
            <DefaultButton
              id={'add-contract-button'}
              small
              icon={Icon('plus.svg')}
              onClick={() => setFilePrompt('contract')}
            >
              Novo contrato
            </DefaultButton>
          </div>
          <div style={{ marginTop: 32, marginBottom: 32 }}>
            {filePrompt && (
              <UploadFile
                edit
                disableInput
                options={options}
                nameFilePlaceholder={
                  filePrompt === 'contract' ? 'Novo Contrato' : 'Novo Documento'
                }
                onClickTrash={() => setFilePrompt(undefined)}
                onClickCheck={(name: string) => {
                  if (!name) return
                  setInputList((cur) => [
                    ...cur,
                    { type: filePrompt, id: UUID(), name },
                  ])
                  setFilePrompt(undefined)
                }}
              />
            )}
          </div>
        </>
      )}

      {/* Inputlist */}
      {inputList.some((input) => input.type === 'contract') && (
        <>
          <div className="subtitle">
            <h4>Contratos</h4>
          </div>
          <div
            style={{
              marginTop: 32,
              marginBottom: 32,
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {inputList
              .filter((item: IObject) => item.type === 'contract')
              .map((item: IObject, i: number) => {
                return (
                  <div
                    key={`contract-${i}`}
                    style={{ marginRight: 20, marginBottom: 20 }}
                  >
                    <UploadFile
                      flag={item?.status}
                      mandatory={item?.mandatory}
                      id={item.id}
                      edit
                      ready
                      noDeleteFile
                      visualize
                      disableInput={readonly || readAdd}
                      file={item.url ? item : undefined}
                      options={options}
                      fileName={item.name}
                      onChangeFile={(name: string, file: any) => {
                        fileList.current.append('contractList', file, name)
                        handleUpdate()
                      }}
                      onClickTrash={(name: string) => {
                        const c = String(
                          fileList.current.get('removeList') || '[]'
                        )
                        const removeList = JSON.parse(c)
                        removeList.push(`contract/${name}`)
                        fileList.current.set(
                          'removeList',
                          JSON.stringify(removeList)
                        )
                        fileList.current.delete(name)

                        setInputList((cur) =>
                          cur.filter((d) => d.name !== name)
                        )
                        handleUpdate()
                      }}
                    />
                  </div>
                )
              })}
          </div>
        </>
      )}
      {inputList.some((input) => input.type === 'document') && (
        <>
          <div className="subtitle">
            <h4>Documentos</h4>
          </div>
          <div
            style={{
              marginTop: 32,
              marginBottom: 32,
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {inputList
              .filter((item: IObject) => item.type === 'document')
              .map((item: IObject, k: number) => {
                return (
                  <div
                    key={`document-${k}`}
                    style={{ marginRight: 20, marginBottom: 20 }}
                  >
                    <UploadFile
                      flag={item?.status}
                      mandatory={item?.mandatory}
                      id={item.id}
                      edit
                      ready
                      noDeleteFile
                      visualize
                      disableInput={readonly || readAdd}
                      options={options}
                      file={item.url ? item : undefined}
                      fileName={item.name}
                      onChangeFile={(name: string, file: any) => {
                        fileList.current.append('documentList', file, name)
                        handleUpdate()
                      }}
                      onClickTrash={(name: string) => {
                        const c = String(
                          fileList.current.get('removeList') || '[]'
                        )
                        const removeList = JSON.parse(c)
                        removeList.push(`document/${name}`)
                        fileList.current.set(
                          'removeList',
                          JSON.stringify(removeList)
                        )
                        fileList.current.delete(name)

                        setInputList((cur) =>
                          cur.filter((i) => i.name !== name)
                        )
                        handleUpdate()
                      }}
                    />
                  </div>
                )
              })}
          </div>
        </>
      )}
      {inputList.some((input) => input.type === 'attachment') && (
        <>
          <div className="subtitle">
            <h4>Anexos</h4>
          </div>
          <div
            style={{
              marginTop: 32,
              marginBottom: 32,
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {inputList
              .filter((item: IObject) => item.type === 'attachment')
              .map((item: IObject, k: number) => {
                return (
                  <div
                    key={`attachment-${k}`}
                    style={{ marginRight: 20, marginBottom: 20 }}
                  >
                    <UploadFile
                      flag={item?.status}
                      mandatory={item?.mandatory}
                      id={item.id}
                      edit
                      ready
                      visualize
                      noDeleteFile
                      disableInput={readonly || readAdd}
                      options={options}
                      file={item.url ? item : undefined}
                      fileName={item.name}
                      onChangeFile={(name: string, file: any) => {
                        fileList.current.append('attachmentList', file, name)
                        handleUpdate()
                      }}
                      onClickTrash={(name: string) => {
                        const c = String(
                          fileList.current.get('removeList') || '[]'
                        )
                        const removeList = JSON.parse(c)
                        removeList.push(`attachment/${name}`)
                        fileList.current.set(
                          'removeList',
                          JSON.stringify(removeList)
                        )
                        fileList.current.delete(name)

                        setInputList((cur) =>
                          cur.filter((i) => i.name !== name)
                        )
                        handleUpdate()
                      }}
                    />
                  </div>
                )
              })}
          </div>
        </>
      )}
    </Formulary>
  )
}
